// extracted by mini-css-extract-plugin
export var actionText = "_nk-4";
export var container = "_nk-0";
export var leftSection = "_nk-1";
export var rightSection = "_nk-2";
export var settingsButton = "_nk-6";
export var settingsIcon = "_nk-7";
export var shortcut = "_nk-5";
export var shortcutGroup = "_nk-3";